import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { queryDeviceTreeList } from '@/api'
import { CODE_ENUM } from '@/common'
import { debounce } from 'lodash'

const TREESIZE = 200

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['orgId'],
  setup(__props, { expose: __expose }) {

const props = __props

watch(
  () => props.orgId,
  () => {
    queryDevice()
  }
)

const options = ref([])
const loading = ref(false)

const queryDevice = async (deviceName?: string) => {
  loading.value = true
  const res: any = await queryDeviceTreeList({
    deviceName,
    treeSize: TREESIZE,
    orgId: props.orgId,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    options.value = (res.data || []).map(
      ({ deviceName, deviceId, ...p }: any) => {
        return {
          label: deviceName,
          value: deviceId,
          ...p,
        }
      }
    )
  }
}

const clear = () => {
  queryDevice()
}

const remoteMethod = queryDevice

queryDevice()

const getOps = () => {
  return options.value
}

__expose({
  getOps,
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!

  return (_openBlock(), _createBlock(_component_el_select_v2, {
    filterable: "",
    remote: "",
    "remote-method": _unref(remoteMethod),
    options: options.value,
    loading: loading.value,
    class: "ws_select",
    clearable: "",
    onClear: clear
  }, null, 8, ["remote-method", "options", "loading"]))
}
}

})